import styles from './Nav.module.scss';
import ItemMenu from './ItemMenu/ItemMenu';
import DecorLogo from './DecorLogo/DecorLogo';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const Nav = (props) => {
  const location = useLocation();
  const projectList = useSelector((state) => state.projects.projects);
  const webinarList = useSelector((state) => state.webinars.webinars);

  const [menuValues, setMenuValues] = useState([]);

  useEffect(() => {
    let baseMenu = [
      { link: '/', name: 'Главная' },
      { link: '/about', name: 'О нас' },
      { link: '/news', name: 'Новости' },
      { link: '/objects', name: 'Объекты' },
      { link: '/documents', name: 'Документация' },
      { link: '/masterplan', name: 'Мастер-планы' },
      { link: '/contests', name: 'Конкурсы' },
      { link: '/purchases/agregator/ano', name: 'Закупки' },
      { link: '/registry', name: 'Подрядчики' },
      { link: '/partners', name: 'Партнеры' },
    ];

    if (projectList && projectList.length > 0) {
      baseMenu.splice(3, 0, { link: '/projects', name: 'Проекты' });
    }

    if (webinarList && webinarList.length > 0) {
      baseMenu.splice(4, 0, { link: '/webinars', name: 'Вебинары' });
    }
    // if (location.pathname.includes('/masterplan/') && !location.pathname.includes('/ideas')) {
    //   baseMenu = [
    //     { link: '/masterplan#news', name: 'Новости' },
    //     { link: '#stages', name: 'Этапы' },
    //     { link: '#docs', name: 'Документы' },
    //     { link: '#photo', name: 'Фото' },
    //   ];
    // } else if (location.pathname.includes('/ideas')) {
    //   baseMenu = [
    //     { link: '/masterplan#news', name: 'Новости' },
    //     { link: '/masterplan', name: 'Мастер-планы' },
    //   ];
    // }

    setMenuValues(baseMenu);
  }, [location, projectList, webinarList]);
  return (
    <nav className={classnames(props.isShowMenu ? [styles.nav, styles.open] : [styles.nav])}>
      <ul>
        {menuValues.map((item, index) => (
          <ItemMenu
            key={index}
            toggleMenu={props.toggleMenu}
            isWhiteText={props.isWhiteText}
            isShowMenu={props.isShowMenu}
            name={item.name}
            link={item.link}
          />
        ))}
      </ul>
      <DecorLogo isShowMenu={props.isShowMenu} />
    </nav>
  );
};

export default Nav;
